module.exports = __webpack_public_path__ + "officialStatic/img/logo2.6483fcf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/about/logo2.png
// module id = NXXV
// module chunks = 0